module.exports = __webpack_public_path__ + "img/icon-bolt.41c10d52.svg";